export default __webpack_public_path__ + "1a697d6533872042e6dc1807ede491e9.svg";